<!--下载插件-->
<template>
  <div class="home">
    <div class="top_box">
      <div class="title">Fatkun 图片批量下载工具</div>
      <div class="describe">
        Fatkun
        是一款内嵌到浏览器的工具，可以帮你方便地从任意网站上批量采集喜欢的图片并迅速完成筛选和保存
      </div>
       <a href="https://aidprintfile.oss-cn-chengdu.aliyuncs.com/down/fatkun.zip" download="fatkun-pro.crx">
          <Button icon="ios-download-outline" type="primary" class="download">立即下载</Button>
       </a>
    </div>
    <div class="mytab">
      <tabs v-model="active">
        <tab title="安装步骤">
          <div class="content">
            <div class="title">● 支持的浏览器</div>
            <div class="describe">
              支持谷歌 Chrome、360、QQ、2345、百度、UC、猎豹等所有谷歌 chrome
              内核浏览器及 Firefox 浏览器
            </div>
            <div class="title">● 手动安装.crx 方法</div>
            <div class="describe">
              如果你无法通过谷歌Chrome
              网上应用店安装，你可要选择手动下载安装包的方式来安装，
              这篇教程适用于谷歌 Chrome、360极速、QQ、UC、猎豹、百度浏览器
            </div>
            <div class="title">● 步骤一：下载安装文件</div>
            <div class="describe">
              点击上方按钮下载 zip 文件，等待下载完成后，将文件解压缩。
            </div>
            <div class="describe describe2">
              360 浏览器可以忽略后续步骤，将 zip 解压缩后得到的 crx
              文件直接拖动到浏览器就可以完成安装。
            </div>
            <div class="title">● 步骤二：打开扩展程序页面</div>
            <div class="describe">
              点击 谷歌 Chrome
              浏览器右上角菜单栏，从“更多工具”中打开“扩展程序”。
            </div>
            <div class="img"><img src="../../assets/images/plug1.jpg" /></div>
            <div class="title">● 步骤三：在右上角打开“开发者模式”</div>
            <div class="describe">
              注：谷歌 Chrome 69 版本后，需要打开开发者模式才能够进行手动安装。
            </div>
            <div class="img"><img src="../../assets/images/plug2.jpg" /></div>
            <div class="title">● 步骤四：拖拽 crx 文件进行安装</div>
            <div class="describe">
              将刚才解压缩后的 crx 文件拖拽至“扩展程序”页面中。
            </div>
            <div class="img"><img src="../../assets/images/plug3.jpg" /></div>
            <div class="title">● 步骤五：点击弹出窗口的“添加扩展程序”</div>
            <div class="img"><img src="../../assets/images/plug4.jpg" /></div>
            <div class="title">● 步骤六：完成安装</div>
            <div class="img"><img src="../../assets/images/plug5.jpg" /></div>
          </div>
        </tab>
        <tab title="使用方法">
          <div class="content">
            <div class="title">● 抓取图片、视频</div>
            <div class="describe">
              在浏览器中打开购物网站中需要抓取的商品，点击抓取工具图标
            </div>
            <div class="img"><img src="../../assets/images/plug6.jpg" /></div>
            <div class="title">● 在下拉菜单中选择“下载当前页面”</div>
            <div class="img"><img src="../../assets/images/plug7.jpg" /></div>
            <div class="title">
              ● 此时将分类展示主图、视频、SKU
              图片、详情的图片，挑选出不需要的图片，并去除选中框（默认全选），整理完成后点击“下载”
            </div>
            <div class="img"><img src="../../assets/images/plug8.jpg" /></div>
            <div class="title">
              ● 等待下载完成，一下子的图片会有绿色勾选图标
            </div>
            <div class="img"><img src="../../assets/images/plug9.jpg" /></div>
            <div class="title">
              ●下载完成后，此商品的所有图片将整理在同一个文件夹，文件名的数字代表此类图片排序，请按此顺序进行新增商品
            </div>
            <div class="img"><img src="../../assets/images/plug10.jpg" /></div>
          </div>
        </tab>
      </tabs>
    </div>
    <div class="top_box bottom">
      <div class="title">Fatkun 图片批量下载工具</div>
      <div class="describe">
        Fatkun
        是一款内嵌到浏览器的工具，可以帮你方便地从任意网站上批量采集喜欢的图片并迅速完成筛选和保存
      </div>
       <a href="https://aidprintfile.oss-cn-chengdu.aliyuncs.com/down/fatkun.zip" download="fatkun-pro.crx">
          <Button icon="ios-download-outline" type="primary" class="download">立即下载</Button>
       </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import tab from "@/components/mytab/tab.vue";
import tabs from "@/components/mytab/tabs.vue";
export default {
  components: {
    tab,
    tabs,
  },
  data() {
    return {
      active: 0,
    };
  },
  mounted() {},
  methods: {
    download() {
    
    },
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
